import { Modal, Row, Col, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

const SECTION_COLOR = '#435986';
const STATUS_GREEN = '#0e9e40';
const STATUS_RED = '#db231c';

const argusModeMessageId = (mode) => {
  return mode.toLowerCase() === 'av' 
    ? 'USER_OBJECTS.ARGUS_MODE_ANTIVIRUS' 
    : `USER_OBJECTS.ARGUS_MODE_${mode.toUpperCase()}`;
};

const SectionHeader = (props) => (
  <>
    <div
      className="font-weight-bold mt-4 mb-2"
      style={{ color: SECTION_COLOR, fontSize: '.8rem', letterSpacing: '.06em', textTransform: 'uppercase' }}
    >
      <FormattedMessage id={props.labelId} />
    </div>
    <hr className="mt-0 mb-3" style={{ borderColor: 'rgba(0,0,0,.08)' }} />
  </>
);

const StatusDot = (props) => {
  const color = props.active ? STATUS_GREEN : STATUS_RED;
  return (
    <span className="d-flex align-items-center">
      <span
        className="mr-2"
        style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: color, display: 'inline-block' }}
      />
      <span style={{ color, fontWeight: 600 }}>
        <FormattedMessage id={props.active ? props.activeLabelId : props.inactiveLabelId} />
      </span>
    </span>
  );
};

const InfoRow = (props) => (
  <Row className="align-items-center mb-3">
    <Col md={5}>
      <span className="font-weight-bold">
        <FormattedMessage id={props.labelId} />
      </span>
    </Col>
    <Col md={7}>{props.children}</Col>
  </Row>
);

const ArgusDeviceInfoModal = ({ show, onHide, device }) => {
  const hasArgusData = !!(device?.argus_version || device?.argus_last_update_at);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id="USER_OBJECTS.ARGUS_STATUS" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SectionHeader labelId="USER_OBJECTS.ARGUS_SECTION_SERVICE_STATUS" />

        <InfoRow labelId="USER_OBJECTS.ARGUS_REACHABLE_LABEL">
          <StatusDot
            active={!!device?.argus_reachable}
            activeLabelId="USER_OBJECTS.ARGUS_REACHABLE_YES"
            inactiveLabelId="USER_OBJECTS.ARGUS_REACHABLE_NO"
          />
        </InfoRow>

        {hasArgusData ? (
          <>
            <InfoRow labelId="USER_OBJECTS.ARGUS_ENABLED_LABEL">
              <StatusDot
                active={!!device?.argus_enabled}
                activeLabelId="USER_OBJECTS.ARGUS_ENABLED_YES"
                inactiveLabelId="USER_OBJECTS.ARGUS_ENABLED_NO"
              />
            </InfoRow>
            <InfoRow labelId="USER_OBJECTS.ARGUS_ACTUAL_MODE">
              {device?.argus_mode ? (
                <FormattedMessage id={argusModeMessageId(device.argus_mode)} />
              ) : (
                '-'
              )}
            </InfoRow>

            <SectionHeader labelId="USER_OBJECTS.ARGUS_SECTION_VERSION_INFO" />

            <InfoRow labelId="USER_OBJECTS.ARGUS_VERSION">
              {device?.argus_version || '-'}
            </InfoRow>
            <InfoRow labelId="USER_OBJECTS.ARGUS_MODEL_VERSION">
              {device?.argus_model_version || '-'}
            </InfoRow>
            <InfoRow labelId="USER_OBJECTS.ARGUS_LAST_UPDATE">
              {device?.argus_last_update_at
                ? moment(device.argus_last_update_at).format('DD-MM-YYYY HH:mm:ss')
                : '-'}
            </InfoRow>

            <SectionHeader labelId="USER_OBJECTS.ARGUS_SECTION_SCAN_STATS" />

            <InfoRow labelId="USER_OBJECTS.ARGUS_SCANNED">
              {device?.argus_scanned_count ?? 0}
            </InfoRow>
            <InfoRow labelId="USER_OBJECTS.ARGUS_BLOCKED">
              {device?.argus_blocked_count ?? 0}
            </InfoRow>
            <InfoRow labelId="USER_OBJECTS.ARGUS_SCAN_ERRORS">
              {device?.argus_scan_errors_count ?? 0}
            </InfoRow>
            <InfoRow labelId="USER_OBJECTS.ARGUS_OVERSIZE">
              {device?.argus_oversize_count ?? 0}
            </InfoRow>
          </>
        ) : (
          <div className="text-muted mt-3">
            <FormattedMessage id="USER_OBJECTS.ARGUS_NO_DATA" />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          <FormattedMessage id="GENERAL.CLOSE" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ArgusDeviceInfoModal;
